import { createEnum } from "../utils/enum-util";

export const AdTargetingRule = createEnum({
    NONE: {
        name: "All",
    },
    INCLUDE: {
        name: "Include",
    },
    EXCLUDE: {
        name: "Exclude",
    },
});
